import React from 'react';
import {
  Dialog,
  DialogContent,
} from './ui/dialog';
import { Button } from './ui/button';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';

const NeededDocumentsModal = ({ isOpen, onClose, neededDocuments }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px] bg-white" hideClose>
        <div className="py-6 px-4">
          <h2 className="text-3xl font-bold text-blue-500 text-center mb-2">
            Claims Intake Form
          </h2>
          
          <div className="mt-8 mb-6">
            <p className="text-2xl font-bold text-orange-500 underline text-center mb-8">
              Pictures/Documents below are still needed!
            </p>
            
            <div className="space-y-3">
              {neededDocuments.map((doc) => (
                <div key={doc} className="flex items-center space-x-3">
                  <Checkbox
                    id={`needed-${doc}`}
                    disabled
                    className="w-5 h-5 border-2 flex-shrink-0"
                  />
                  <Label htmlFor={`needed-${doc}`} className="text-base text-gray-600">
                    {doc}
                  </Label>
                </div>
              ))}
            </div>
          </div>
          
          <div className="flex justify-end mt-8">
            <Button 
              onClick={onClose}
              className="bg-transparent hover:bg-blue-50 text-blue-500 border-none shadow-none text-xl"
            >
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NeededDocumentsModal;
